import type { Data } from '@/types/chart';
import { zoned } from '@/utils/dates';

export const accessor = {
  getValue: (d: Data) => d.value,
  getDate: (d: Data) => zoned(d.date),
};
